import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const Trade: RouteRecordRaw = {
  name: "交易管理",
  path: "/trade",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  meta: {
    key: "/trade"
  },
  children: [
    {
      name: "申单",
      path: "apply",
      component: () => import("@/views/Trade/Apply/index.vue").catch(onError),
      meta: {
        key: "/trade/apply",
        keepAlive: true
      }
    },
    {
      name: "批单",
      path: "approve",
      component: () => import("@/views/Trade/Approve/index.vue").catch(onError),
      meta: {
        key: "/trade/approve",
        keepAlive: true
      }
    },
    {
      name: "交易查询",
      path: "trade-list",
      component: () =>
        import("@/views/Trade/TradeList/index.vue").catch(onError),
      meta: {
        key: "/trade/trade-list",
        keepAlive: true
      }
    },
    {
      name: "预算调整",
      path: "cap-adjust",
      component: () =>
        import("@/views/Trade/CapAdjust/index.vue").catch(onError),
      meta: {
        key: "/trade/cap-adjust",
        keepAlive: true
      }
    },
    {
      name: "上游月度数据补录",
      path: "upstream-manual-data",
      component: () =>
        import("@/views/Trade/UpstreamManualData/index.vue").catch(onError),
      meta: {
        key: "/trade/upstream-manual-data",
        keepAlive: true
      }
    },
    {
      name: "下游月度数据补录",
      path: "downstream-manual-data",
      component: () =>
        import("@/views/Trade/DownstreamManualData/index.vue").catch(onError),
      meta: {
        key: "/trade/downstream-manual-data",
        keepAlive: true
      }
    },
    {
      name: "日度线下数据导入",
      path: "daily-data-import",
      component: () =>
        import("@/views/Trade/DailyDataImport/index.vue").catch(onError),
      meta: {
        key: "/trade/daily-data-import"
      }
    },
    {
      name: "上游确认率管理",
      path: "adv-confirmation-modify",
      component: () =>
        import("@/views/Trade/AdvConfirmationModify/index.vue").catch(onError),
      meta: {
        key: "/adv-confirmation-modify",
        keepAlive: true
      }
    },
    {
      name: "生效配置查询",
      path: "trm-check",
      component: () =>
        import("@/views/Trade/TrmCheck/index.vue").catch(onError),
      meta: {
        key: "/trade/trm-check"
      }
    },
    {
      name: "交易地区检测",
      path: "trade-checking",
      component: () =>
        import("@/views/Trade/TradeCheck/index.vue").catch(onError),
      meta: {
        key: "/trade/trade-checking"
      }
    },
    {
      name: "BDC配置",
      path: "bdc-task-config",
      component: () =>
        import("@/views/Trade/BdcTaskConfig/index.vue").catch(onError),
      meta: {
        key: "/trade/bdc-task-config",
        keepAlive: true
      }
    },
    {
      name: "H5线下数据管理",
      path: "h5-data-manage",
      component: () =>
        import("@/views/Trade/OfflineDataManagement/index.vue").catch(onError),
      meta: {
        key: "/trade/h5-data-manage"
      }
    },
    {
      name: "透明媒体自投/代投批单",
      path: "media-proxy-approve",
      component: () =>
        import("@/views/Trade/MediaProxyApprove/index.vue").catch(onError),
      meta: {
        key: "/trade/media-proxy-approve",
        keepAlive: true
      }
    },
    {
      name: "交易匹配管理",
      path: "trade-matching",
      component: () =>
        import("@/views/Trade/TradeMatching/index.vue").catch(onError),
      meta: {
        key: "/trade/trade-matching"
      }
    },
    {
      name: "拉黑记录",
      path: "block-record",
      component: () =>
        import("@/views/Trade/BlockRecord/index.vue").catch(onError),
      meta: {
        key: "/trade/block-record",
        keepAlive: true
      }
    }
  ]
};

export default Trade;
